module.exports = __webpack_public_path__ + "img/9791159922497.83fef38e.jpg";